import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import axios from "axios";
import { URL_API } from "config";
import { useNavigate } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "pages/auth/login/config";
import { toast } from "react-toastify";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState();
  const [user, setUser] = useState();
  const [openAlert, setOpenAlert] = useState(false);

  const navigate = useNavigate();

  const isAuthenticated = useIsAuthenticated();

  const { instance } = useMsal();

  useEffect(() => {
    const token = localStorage.getItem("Tag");
    const user = localStorage.getItem("User");
    const alertedPopUp = localStorage.getItem("AlertedPopUp");

    if (token) setToken(JSON.parse(JSON.stringify(token)));

    if (user) {
      setUser(JSON.parse(user));
    }

    if (alertedPopUp === "true") setOpenAlert(false);
  }, [token]);

  const login = useCallback(async (encoded, type) => {
    if (type === "company") {
      await axios
        .post(URL_API + "/auth", null, {
          headers: {
            Authorization: `Basic ${encoded}`,
          },
        })
        .then((response) => {
          localStorage.setItem(
            "User",
            JSON.stringify({
              email: response.data.user.email,
              name: response.data.user.name,
              profile:
                !response.data.user.company_id &&
                response.data.user?.profile === 99
                  ? 99
                  : 1,
              company_id: response.data.user.company_id,
              uuid: response.data.user.uuid,
            })
          );
          localStorage.setItem("Tag", response.data.token);
          localStorage.setItem("AlertedPopUp", false);

          setUser(
            JSON.stringify({
              email: response.data.user.email,
              name: response.data.user.name,
              profile:
                !response.data.user.company_id &&
                response.data.user?.profile === 99
                  ? 99
                  : 1,
              company_id: response.data.user.company_id,
              uuid: response.data.user.uuid,
            })
          );

          setToken(response.data.token);
          setOpenAlert(true);
          toast.success("Login realizado");
          navigate("/admin/dashboard");
        })
        .catch((error) => {
          if (error?.response?.status === 405) {
            navigate(`/auth/terms/${error?.response?.data?.uuid}`);
          } else {
            toast.error("Não foi possível fazer login");
            localStorage.removeItem("Tag");
            localStorage.removeItem("User");
            localStorage.removeItem("AlertedPopUp");
          }
        });
    }

    if (type === "azure") {
      await axios
        .post(URL_API + "/auth", null, {
          headers: {
            Authorization: `Basic ${encoded}`,
          },
        })
        .then((response) => {
          localStorage.setItem(
            "User",
            JSON.stringify({
              email: response.data.user.email,
              name: response.data.user.name,
              profile: response.data.user?.profile,
              company_id: response.data.user.company_id,
              uuid: response.data.user.uuid,
            })
          );
          localStorage.setItem("Tag", response.data.token);
          localStorage.setItem("AlertedPopUp", false);

          setUser(
            JSON.stringify({
              email: response.data.user.email,
              name: response.data.user.name,
              profile: response.data.user?.profile,
              company_id: response.data.user.company_id,
              uuid: response.data.user.uuid,
            })
          );

          setToken(response.data.token);
          setOpenAlert(true);
          toast.success("Login realizado");
          navigate("/admin/dashboard");
        })
        .catch((error) => {
          if (error?.response?.status === 405) {
            navigate(`/auth/terms/${error?.response?.data?.uuid}`);
          } else if (sessionStorage.length) {
            sessionStorage.clear();
            toast.error("Não foi possível fazer login");
            localStorage.removeItem("Tag");
            localStorage.removeItem("User");
          } else {
            localStorage.removeItem("Tag");
            localStorage.removeItem("User");
          }
        });
    }
    // eslint-disable-next-line
  }, []);

  const logout = useCallback(async () => {
    if (isAuthenticated) {
      await instance.logoutRedirect(loginRequest);
      sessionStorage.clear();
    }

    localStorage.removeItem("Tag");
    localStorage.removeItem("User");
    localStorage.removeItem("AlertedPopUp");

    navigate("/auth/login");

    setToken(undefined);
    // eslint-disable-next-line
  }, []);

  const authenticated = useMemo(() => !!token, [token]);

  const handleAlert = async () => {
    localStorage.setItem("AlertedPopUp", true);
    setOpenAlert(false);

    // const alert = new Date().toISOString();

    // await axios
    //   .put(
    //     URL_API + `/user/${user?.uuid}`,
    //     { alert },
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     }
    //   )
    //   .then(() => {
    //     setOpenAlert(false);
    //     localStorage.setItem(
    //       "User",
    //       JSON.stringify({
    //         email: user.email,
    //         name: user.name,
    //         profile: user?.profile,
    //         company_id: user.company_id,
    //         uuid: user.uuid,
    //         alert,
    //       })
    //     );
    //     setUser({
    //       email: user.email,
    //       name: user.name,
    //       profile: user?.profile,
    //       company_id: user.company_id,
    //       uuid: user.uuid,
    //       alert,
    //     });
    //   })
    //   .catch((error) => {
    //     if (error?.response?.status === 401) {
    //       localStorage.removeItem("Tag");
    //       navigate("/auth/login");
    //     } else {
    //       toast.error(error?.response?.data?.message);
    //     }
    //   });
  };

  const value = useMemo(
    () => ({
      authenticated,
      user,
      openAlert,
      handleAlert,
      login,
      logout,
      token,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [authenticated, user, openAlert, login, logout, token]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => {
  const { authenticated, user, openAlert, handleAlert, login, logout, token } =
    useContext(AuthContext);

  return {
    authenticated,
    user,
    openAlert,
    handleAlert,
    login,
    logout,
    token,
  };
};
